module.exports = __webpack_public_path__ + "img/_Slide9.86c8e123.jpg";